import { AsyncPullLoadingIndicator } from './AsyncPullLoadingIndicator'

type Props = {
  angular: boolean
  label?: string
}

/** 生图页：拉取 `/v1/platform-configs` 前仅展示与图库/时间线一致的下拉刷新动画，不渲染表单骨架 */
export function PlatformConfigLoadingPanel({
  angular,
  label = '正在加载模型配置…',
}: Props) {
  return <AsyncPullLoadingIndicator angular={angular} label={label} className="pb-4" />
}
